'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418 from "./presto.-Register-Page-View$$anon$18.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244 from "./presto.-Register-Page-View$$anon$4.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$3(outer) {
  this.btw = null;
  this.bto = null;
  this.btp = false;
  this.btx = null;
  this.bty = false;
  this.btB = null;
  this.btu = null;
  this.btv = false;
  this.btq = null;
  this.btr = false;
  this.bts = null;
  this.btt = false;
  this.btz = false;
  this.btA = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.btw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.btB = "SingleAppToken";
}
export { $c_Lpresto_RegisterPageView$$anon$3 as $c_Lpresto_RegisterPageView$$anon$3 };
$p = $c_Lpresto_RegisterPageView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$3;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$3() {
}
export { $h_Lpresto_RegisterPageView$$anon$3 as $h_Lpresto_RegisterPageView$$anon$3 };
$h_Lpresto_RegisterPageView$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.btw;
});
$p.M = (function() {
  if ((!this.btp)) {
    this.bto = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.btp = true;
  }
  return this.bto;
});
$p.O = (function() {
  if ((!this.bty)) {
    this.btx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bty = true;
  }
  return this.btx;
});
$p.E = (function() {
  return this.btB;
});
$p.t = (function() {
  if ((!this.btv)) {
    this.btu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.btv = true;
  }
  return this.btu;
});
$p.N = (function() {
  if ((!this.btr)) {
    this.btq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gg())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244.$c_Lpresto_RegisterPageView$$anon$4(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.btr = true;
  }
  return this.btq;
});
$p.Q = (function() {
  if ((!this.btt)) {
    this.bts = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_RegisterPageView$$anon$18();
    this.btt = true;
  }
  return this.bts;
});
$p.v = (function() {
  if ((!this.btA)) {
    this.btz = false;
    this.btA = true;
  }
  return this.btz;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee121) => ((p) => \u03b4scrutinee121.acZ(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_RegisterPageView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$3, "presto.RegisterPageView$$anon$3", ({
  Qo: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$3 as $d_Lpresto_RegisterPageView$$anon$3 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$3.js.map
